const firebaseConfig = {
  apiKey: "AIzaSyBbvYMYhZqiWAsCvLQy8gLQ6JP5NN27Yc0",
  authDomain: "chatroom-45d5f.firebaseapp.com",
  databaseURL: "https://chatroom-45d5f.firebaseio.com",
  projectId: "chatroom-45d5f",
  storageBucket: "chatroom-45d5f.appspot.com",
  messagingSenderId: "196747187449"
};

export default firebaseConfig;


// WEBPACK FOOTER //
// ./src/firebase/firebaseConfig.js